<template>
    <div class="wrap-loading" :style="`width: ${previewWidth}; height: ${previewHeight}`" v-if="value === undefined || loading">
        <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
    <div class="wrap" v-else>
        <input type="file" @change="onFileChange" id="uploader" accept="image/*" style="display: none;" />

        <div class="d-flex align-center justify-center preview-default" v-if="url">
            <div class="upload-text-container">
                <img :src="url" alt="uploaded preview" class="uploaded-image" />
                <img
                    src="../../assets/images/default-image.png"
                    alt="default preview"
                    :style="`width: 90px; height: 90px; cursor: pointer;`"
                    @click="openFileBrowser"
                />
                <div class="upload-text change-text-clickable" @click="openFileBrowser">เปลี่ยนรูปภาพ</div>
            </div>
        </div>
        <div class="d-flex align-center justify-center preview-default" v-else @click="openFileBrowser">
            <div class="upload-text-container">
                <img src="../../assets/images/default-image.png" alt="default preview" :style="`width: 90px; height: 90px;`" />
                <div class="upload-text">อัพโหลดรูปภาพ</div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import imageCompression from 'browser-image-compression';

const _URL = window.URL || window.webkitURL

export default {
    props: ['width', 'height', 'size', 'value', 'previewWidth', 'previewHeight', 'uploadUrl', 'ratio', 'token'],
    data() {
        return {
            url: null,
            loading: false,
        }
    },
    computed: {
        fileInputAccept() {
            return "image/*";
        }
    },
    mounted() {
        if(this.value !== undefined) {
            this.url = this.value
        }

        const userAgent = window.navigator.userAgent,
          platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
          macosPlatforms = ['macOS', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
          windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
          iosPlatforms = ['iPhone', 'iPad', 'iPod'];
        let os = null;

        if (macosPlatforms.indexOf(platform) !== -1) {
          os = 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
          os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
          os = 'Windows';
        } else if (/Android/.test(userAgent)) {
          os = 'Android';
          document.getElementById('uploader').setAttribute("capture", "capture");
        } else if (/Linux/.test(platform)) {
          os = 'Linux';
        }


    },
    updated() {
        if(this.value !== undefined) {
            this.url = this.value
        }
    },
    beforeDestroy() {
        // Component cleanup
    },
    methods: {
        async onFileChange(e) {
            this.loading = true
            const file = e.target.files[0];
            if(file.size > (parseInt(this.size) * 1000000)) {
                this.$toast.error(`อัปโหลดไฟล์รูปขนาดไม่เกิน ${this.size} MB.`)
                this.loading = false
                return
            }

            if(file.type === 'image/png' || file.type === 'image/jpeg') {

                // if(this.ratio) {
                //     const _img_detail = await this.getWidthHeightImg(file)
                //     const imgDetailRatio = _img_detail.width / _img_detail.height

                //     if(this.ratio === '1:1') {
                //         const defaultRatio = 1
                //         if(imgDetailRatio.toFixed(1) != defaultRatio.toFixed(1)) {
                //             this.$toast.error(`Image size must be 300 x 300, 500 x 500, 800 x 800`)
                //             this.loading = false
                //             return
                //         }
                //     }
                //     else if(this.ratio === '4:3') {
                //         const defaultRatio = 4/3
                //         if(imgDetailRatio.toFixed(1) != defaultRatio.toFixed(1)) {
                //             this.$toast.error(`Image ratio must be 4:3`)
                //             this.loading = false
                //             return
                //         }
                //     }
                //     else if(this.ratio === '5:4') {
                //         const defaultRatio = 5/4
                //         if(imgDetailRatio.toFixed(1) != defaultRatio.toFixed(1)) {
                //             this.$toast.error(`Image ratio must be 5:4`)
                //             this.loading = false
                //             return
                //         }
                //     }
                //     else if(this.ratio === '4:5') {
                //         const defaultRatio = 4/5
                //         if(imgDetailRatio.toFixed(1) != defaultRatio.toFixed(1)) {
                //             this.$toast.error(`Image ratio must be 64 x 80, 678 x 848, 1080 x 1350`)
                //             this.loading = false
                //             return
                //         }
                //     }
                //     else if(this.ratio === '3:2') {
                //         const defaultRatio = 3/2
                //         if(imgDetailRatio.toFixed(1) != defaultRatio.toFixed(1)) {
                //             this.$toast.error(`Image size must 900 x 600`)
                //             this.loading = false
                //             return
                //         }
                //     }
                //     else if(this.ratio === '8:5') {
                //         const defaultRatio = 8/5
                //         if(imgDetailRatio.toFixed(1) != defaultRatio.toFixed(1)) {
                //             this.$toast.error(`Image size must be 1598 × 1024`)
                //             this.loading = false
                //             return
                //         }
                //     }
                //     else if(this.ratio === '16:9') {
                //         const defaultRatio = 16/9
                //         if(imgDetailRatio.toFixed(1) != defaultRatio.toFixed(1)) {
                //             this.$toast.error(`Image size must be 960 x 540, 1024 x 576, 1280 x 720`)
                //             this.loading = false
                //             return
                //         }
                //     }
                //     else if(this.ratio === '2.4:1') {
                //         const defaultRatio = 2.4/1
                //         if(imgDetailRatio.toFixed(1) != defaultRatio.toFixed(1)) {
                //             this.$toast.error(`Image size must be 1280 x 533, 1920 x 800`)
                //             this.loading = false
                //             return
                //         }
                //     }
                //     else if(this.ratio === '20:13') {
                //         const defaultRatio = 20/13
                //         if(imgDetailRatio.toFixed(1) != defaultRatio.toFixed(1)) {
                //             this.$toast.error(`Image size must be 20:13 (400 x 260)`)
                //             this.loading = false
                //             return
                //         }
                //     }
                //     else {
                //         if(this.width && this.height) {
                //             const defaultRatio = this.width/this.height
                //             if(imgDetailRatio.toFixed(1) != defaultRatio.toFixed(1)) {
                //                 this.$toast.error(`Image size must be ${this.width} x ${this.height}`)
                //                 this.loading = false
                //                 return
                //             }
                //         }
                //     }
                // }

                const imageFile = file;

                // Read the file and apply smart compression if needed
                let reader = new FileReader()
                reader.readAsDataURL(imageFile)
                reader.onloadend = async (event) => {
                    try {
                        // Apply high-quality compression if image is larger than 3.5MB
                        const compressedImage = await this.compressImageIfNeeded(event.target.result, 3.5);
                        this.$emit('input', compressedImage);
                        this.loading = false;
                    } catch (error) {
                        // Fallback to original image if compression fails
                        this.$emit('input', event.target.result);
                        this.loading = false;
                    }
                }

                // imageCompression(imageFile, options)
                //     .then(function (compressedFile) {
                //         console.log('compressedFile instanceof Blob', compressedFile); // true
                //         console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

                //         let reader = new FileReader()
                //         reader.readAsDataURL(file)
                //         reader.onloadend = async (event) => {
                //             console.log(event.target.result);
                //             this.$emit('input', event.target.result)
                //         }

                //         // return uploadToServer(compressedFile); // write your own logic
                //     })
                //     .catch(function (error) {
                //         console.log(error.message);
                //     });

                // let reader = new FileReader()
                // reader.readAsDataURL(file)
                // reader.onloadend = async (event) => {
                // //     // axios.post(this.uploadUrl || '', {
                // //     //     base64 :event.target.result
                // //     // }, {
                // //     //     headers: {
                // //     //         Authorization: this.token || ''
                // //     //     }
                // //     // })
                // //     //     .then(response => {
                //     // console.log(reader);
                //     // console.log(imgCompressed);
                //             this.$emit('input', await this.compressImage(imgCompressed, 75)) // set to 75%)
                // //     //         this.$emit('apiResponse', response.data)
                // //     //         this.$emit('getData', response.data.data, file.name)
                // //     //         this.loading = false
                // //     //     })
                // //     //     .catch(err => {
                // //     //         if(err.response.data) {
                // //     //             this.$emit('errorResponse', err.response.data)
                // //     //         }
                // //     //         this.loading = false
                // //     //     })
                //     this.loading = false
                // //     // console.log(reader.result);
                // }
                // reader.readAsDataURL(file)
            }
            else {
                this.$toast.error(`อัปโหลดไฟล์รูป .jpg , png เท่านั้น`)
                this.loading = false
            }
        },
        onImageRemoveClick() {
            this.url = ''
            document.getElementById('uploader').value = ''
            localStorage.removeItem('image');
            this.$emit('input', '')
        },
        openFileBrowser() {
            const userAgent = window.navigator.userAgent,
            
            platform = window.navigator?.userAgentData?.platform || window.navigator.platform,
            macosPlatforms = ['macOS', 'Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'];
            let os = null;

            if (macosPlatforms.indexOf(platform) !== -1) {
                os = 'Mac OS';
            } else if (iosPlatforms.indexOf(platform) !== -1) {
                os = 'iOS';
            } else if (windowsPlatforms.indexOf(platform) !== -1) {
                os = 'Windows';
            } else if (/Android/.test(userAgent)) {
                os = 'Android';
                document.getElementById('uploader').value = '';
                document.getElementById('uploader').setAttribute("capture", "capture");
            } else if (/Linux/.test(platform)) {
                os = 'Linux';
            }

            document.getElementById('uploader').click();
        },
        getWidthHeightImg(file) {
            return new Promise(function (resolve) {
                try {
                    let _img = new Image();
                    _img.src = _URL.createObjectURL(file);
                    _img.onload = function() {
                        resolve({
                            width: _img.width,
                            height: _img.height
                        });
                    };
                } catch (ex) {
                    resolve({
                        width: 9999999,
                        height: 9999999
                    });
                }
            })
        },
        async compressImage(blobImg, percent) {
            let bitmap = await createImageBitmap(blobImg);
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            canvas.width = bitmap.width;
            canvas.height = bitmap.height;
            ctx.drawImage(bitmap, 0, 0);
            let dataUrl = canvas.toDataURL("image/jpeg", percent/100);
            return dataUrl;
        },
        // High-quality image compression for files larger than 3.5MB
        compressImageIfNeeded(base64String, maxSizeMB = 3.5) {
            return new Promise((resolve) => {
                try {
                    // Calculate current size in MB
                    const currentSizeMB = (base64String.length * 0.75) / (1024 * 1024);
                    
                    // If image is under 3.5MB, keep original quality
                    if (currentSizeMB <= maxSizeMB) {
                        resolve(base64String);
                        return;
                    }

                    // Create image element to load the base64
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        const ctx = canvas.getContext('2d');

                        // Keep original dimensions first, only resize if absolutely necessary
                        let { width, height } = img;

                        // Try to compress without resizing first (quality reduction only)
                        canvas.width = width;
                        canvas.height = height;

                        // Enable highest quality rendering
                        ctx.imageSmoothingEnabled = true;
                        ctx.imageSmoothingQuality = 'high';
                        ctx.drawImage(img, 0, 0, width, height);

                        // Progressive quality compression - start high and work down
                        const qualityLevels = [0.95, 0.90, 0.85, 0.80, 0.75, 0.70, 0.65, 0.60];
                        
                        for (let quality of qualityLevels) {
                            const compressed = canvas.toDataURL('image/jpeg', quality);
                            const compressedSizeMB = (compressed.length * 0.75) / (1024 * 1024);
                            
                            if (compressedSizeMB <= maxSizeMB) {
                                resolve(compressed);
                                return;
                            }
                        }

                        // If still too large, try with smaller dimensions while maintaining aspect ratio
                        const scaleFactor = Math.sqrt(maxSizeMB / currentSizeMB * 0.8); // 0.8 for safety margin
                        const newWidth = Math.round(width * scaleFactor);
                        const newHeight = Math.round(height * scaleFactor);

                        canvas.width = newWidth;
                        canvas.height = newHeight;
                        ctx.imageSmoothingEnabled = true;
                        ctx.imageSmoothingQuality = 'high';
                        ctx.drawImage(img, 0, 0, newWidth, newHeight);

                        // Try higher qualities with smaller dimensions
                        const resizedQualities = [0.90, 0.85, 0.80, 0.75, 0.70];
                        
                        for (let quality of resizedQualities) {
                            const compressed = canvas.toDataURL('image/jpeg', quality);
                            const compressedSizeMB = (compressed.length * 0.75) / (1024 * 1024);
                            
                            if (compressedSizeMB <= maxSizeMB) {
                                resolve(compressed);
                                return;
                            }
                        }

                        // Last resort: aggressive compression
                        const finalCompressed = canvas.toDataURL('image/jpeg', 0.6);
                        resolve(finalCompressed);
                    };

                    img.onerror = () => {
                        resolve(base64String);
                    };

                    img.src = base64String;
                } catch (error) {
                    resolve(base64String);
                }
            });
        },
        formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
    },
}
</script>

<style scoped>
.wrap {
    position: relative;
    width: 100%;
    height: 100%;
    /* overflow: hidden; */
    /* border-radius: 10px;
    border: 1px solid #C4C4C4; */
    cursor: pointer;
}

.upload-button input,
.wrap input {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    width: 100%;
    z-index: 100;
}
.upload-button input[type=file],
.upload-button input[type=file]::-webkit-file-upload-button,
.wrap input[type=file],
.wrap input[type=file]::-webkit-file-upload-button {
    cursor: pointer;
}
.preview-default {
    width: 100%;
    height: 100%;
    padding: 12px;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.preview-default img {
    width: 100%;
    /* max-width: 60%; */
    height: calc(100% - 50px); /* Reserve space for text */
    object-fit: contain;
}
.card {
    width: 100%;
    height: 100%;
}
.card-body {
    position: relative;
    height: 100%;
}
.overlay-wrapper {
    width: 100%;
    height: 100%;
    padding: 6px;
    display: flex;
    align-items: center;
    position: relative;
}
.overlay-wrapper img {
    object-fit: contain;
    width: 100%;
    height: 100%;
}
.wrap:hover .overlay-layer {
    display: flex;
}
.overlay-layer {
    border-radius: 9px;
    display: none;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.3);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    justify-content: center;
    align-items: center;
    z-index: 101;
    /* display: flex;
    justify-content: center;
    position: absolute;
    left: -40px;
    left: 0;
    right: 0; */
}
.upload-button {
    position: relative;
    overflow: hidden;
}
.wrap-loading {
    width: 100%;
    height: 100%;
    overflow: hidden;
    /* border-radius: 10px;
    border: 1px solid #C4C4C4; */
    display: flex;
    align-items: center;
    justify-content: center;
}
.lds-ellipsis {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ellipsis div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: black;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
    left: 8px;
    animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
    left: 8px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
    left: 32px;
    animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
    left: 56px;
    animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1);
    }
}
@keyframes lds-ellipsis3 {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(0);
    }
}
@keyframes lds-ellipsis2 {
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(24px, 0);
    }
}

.upload-text-container {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 300px;
}

.uploaded-image {
    width: auto;
    max-width: 100%;
    max-height: 200px;
    object-fit: contain;
    margin-bottom: 16px;
}

/* Better mobile/iOS support */
@media (max-width: 768px) {
    .uploaded-image {
        max-height: 250px;
        max-width: 100%;
    }
}

/* Specific iOS fixes */
@media (max-width: 480px) {
    .uploaded-image {
        max-height: 250px;
        max-width: 100%;
    }
}

.upload-text {
    margin-top: 12px;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    line-height: 1.5;
}

.change-text-clickable {
    cursor: pointer;
    transition: color 0.3s ease;
}
</style>
